import Image from "next/image";
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../context/globalContext";

const FavoriteButton = ({ data, borderStyle, children }) => {
  const { favorites, setFavorites } = useGlobalContext();
  const [isAdded, setIsAdded] = useState(false);

  useEffect(() => {
    setIsAdded(favorites.find((item) => item?.id == data?.id) ? true : false);
    localStorage.setItem("Favourites", JSON.stringify(favorites));
  }, [favorites, data]);

  const onClick = () => {
    const module = import("@/utils/functions/handleFavourite");
    module.then((handleFavourite) => {
      handleFavourite.handleFavourite({ favorites, setFavorites, data });
    });
  };
  return (
    <button
      onClick={onClick}
      type="button"
      className={`${borderStyle} flex items-center justify-center bg-white rounded-full w-9 h-9`}
    >
      {isAdded ? (
        <Image
          src="/icons/activeHeart.svg"
          alt="heart"
          width={14}
          height={14}
          className="object-contain"
        />
      ) : (
        children
      )}
    </button>
  );
};

export default FavoriteButton;
